import detectType from "@shared/scripts/tools/detectType";

export const isMobile = () => {
  return detectType().isMobile;
};

export const addWindowQueue = name => {
  window[`${name}Queue`] = [];
};

export const addResizeListener = (callback, immediate = true) => {
  const handleResize = isFirst => {
    // 调用回调函数，并传入当前是否是移动端的布尔值 (不清楚为什么第一时间拿不到，需要等一下re-render)
    if (isFirst) {
      window.resizeEventQueue.forEach(fn => fn(isMobile()));
    } else {
      setTimeout(() => {
        window.resizeEventQueue.forEach(fn => fn(isMobile()));
      });
    }
  };

  // 监听窗口的 resize 事件
  if (window.resizeEventQueue.length === 0) {
    window.addEventListener("resize", handleResize, false);
  }
  window.resizeEventQueue.push(callback);

  // 立即执行一次，以确保在屏幕尺寸变化前也能获取到当前状态
  immediate && handleResize(true);

  // 返回一个函数，用于取消监听
  return () => {
    window.removeEventListener("resize", handleResize, false);
  };
};

export const rem = (pixels: number) => {
  const vw_design = 375;
  return isMobile() ? `${(pixels / vw_design) * 10}rem` : `${pixels}px`;
};

export const getQuery = (variable: string) => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
};

export const getWh = () => {
  return {
    width: document.body.clientWidth,
    height: document.body.clientHeight,
  };
};

/**
 * create ajax
 * @param {string} url
 * @param {string} method
 * @param {object} data
 * @param {string} datType
 * @param {bool} isAsync
 */
export const createAjax = ({
  url,
  method = "GET",
  data = {},
  isAsync = true,
  dataType = "json",
  Accept = "application/json",
}) => {
  return $.ajax({
    headers: {
      Accept,
    },
    async: isAsync,
    url,
    method,
    dataType,
    data,
  });
};

/**
 * root是要监听的根元素，我们要对root节点内的img元素进行监听
 * 这里用到Promise.all
 */
// export const onAllImgLoaded = async root => {
//   const imgNodes =
//     root instanceof HTMLImageElement ? [root] : root.querySelectorAll("img");
//   //为了使用Array的map方法
//   let imgArr = Array.prototype.slice.call(imgNodes);
//   return await Promise.all(
//     imgArr.map(img => {
//       new Promise(resolve => {
//         img.addEventListener("load", () => resolve(img));
//       });
//     })
//   );
// };

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    console.log("复制成功!");
  } catch (error) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("复制成功!");
    } catch (error) {
      console.log("复制失败!");
    }
    document.body.removeChild(textArea);
  }
}

// export async function loadMarkdown(path: string) {
//   const response = await fetch(path);
//   const markdownText = await response.text();
//   return markdownText;
// }

export function isDarkMode() {
  return (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
}

// export function timestampToCustomFormat(
//   timestamp,
//   format = "YYYY-MM-DD HH:mm:ss"
// ) {
//   if (!timestamp) {
//     return timestamp;
//   }
//   if (typeof timestamp !== "number") {
//     throw new TypeError("timestamp must be a number");
//   }

//   const date = new Date(timestamp);
//   const formats = {
//     YYYY: date.getFullYear(),
//     MM: ("0" + (date.getMonth() + 1)).slice(-2),
//     DD: ("0" + date.getDate()).slice(-2),
//     HH: ("0" + date.getHours()).slice(-2),
//     mm: ("0" + date.getMinutes()).slice(-2),
//     ss: ("0" + date.getSeconds()).slice(-2),
//   };

//   return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => formats[match]);
// }

export function scrollEnd(el: HTMLElement) {
  requestAnimationFrame(() => {
    el.scrollTo({
      behavior: "smooth",
      top: el.scrollHeight,
      left: 0,
    });
  });
}

export function getDeviceInfoFromUserAgent() {
  var userAgent = navigator.userAgent;
  var deviceInfo = {} as {
    isMobile?: boolean;
    os?: string;
    browser?: string;
  };

  // 检测是否为移动设备
  var mobileRegex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  if (mobileRegex.test(userAgent)) {
    deviceInfo.isMobile = true;
  } else {
    deviceInfo.isMobile = false;
  }

  // 检测操作系统
  if (/Android/.test(userAgent)) {
    deviceInfo.os = "Android";
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    deviceInfo.os = "iOS";
  } else if (/Windows NT/.test(userAgent)) {
    deviceInfo.os = "Windows";
  } else if (/Mac OS X/.test(userAgent)) {
    deviceInfo.os = "MacOS";
  } else if (/Linux/.test(userAgent)) {
    deviceInfo.os = "Linux";
  } else {
    deviceInfo.os = "Unknown";
  }

  // 检测浏览器
  if (/Chrome/.test(userAgent)) {
    deviceInfo.browser = "Chrome";
  } else if (/Firefox/.test(userAgent)) {
    deviceInfo.browser = "Firefox";
  } else if (/Safari/.test(userAgent)) {
    deviceInfo.browser = "Safari";
  } else if (/MSIE|Trident/.test(userAgent)) {
    deviceInfo.browser = "Internet Explorer";
  } else if (/Edge/.test(userAgent)) {
    deviceInfo.browser = "Edge";
  } else {
    deviceInfo.browser = "Unknown";
  }

  return deviceInfo;
}

/**
 * 判断当前设备是否为平板（Pad）
 * @returns {boolean}
 */
function isTabletDevice() {
  const ua = (navigator.userAgent || "").toLowerCase();

  // 0. UA 中含 "pad"（调试用）
  if (ua.includes("pad")) {
    return true;
  }

  // 1. iPad 判断（iPadOS Safari 可能把 UA 伪装成 Mac）
  const isIPadUA = /ipad/.test(ua);
  const isIPadTouch =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (isIPadUA || isIPadTouch) {
    return true;
  }

  // 2. Android 平板（排除手机）
  if (/android/.test(ua) && !/mobile/.test(ua)) {
    return true;
  }

  // 3. Windows 平板（Surface 系列）
  if (/windows/.test(ua) && /touch/.test(ua)) {
    return true;
  }

  // 4. 根据屏幕尺寸 & 触摸能力
  const width = Math.max(window.screen.width, window.screen.height);
  const height = Math.min(window.screen.width, window.screen.height);
  const dpr = window.devicePixelRatio || 1;
  const cssW = width / dpr;
  const cssH = height / dpr;

  // 如果是“粗指针”设备，且宽度在平板区间内，也算平板
  const isCoarse = window.matchMedia("(pointer: coarse)").matches;

  // iPad Pro 常见 CSS 视口：1024×1366
  const isIpadProViewport = cssW === 1024 && cssH === 1366;

  // 通用平板尺寸判断：宽度 >= 768 && 高度 >= 600
  const isTabletSize = cssW >= 768 && cssH >= 600;

  if ((isCoarse && isTabletSize) || isIpadProViewport) {
    return true;
  }

  return false;
}

/**
 * 判断当前设备是否为折叠屏展开状态
 * @returns {boolean}
 */
function isFoldableExpanded() {
  // 1. 优先使用 Foldable Display API (screen-spanning)
  if (window.matchMedia) {
    const vertical = window.matchMedia(
      "(screen-spanning: single-fold-vertical)"
    ).matches;
    const horizontal = window.matchMedia(
      "(screen-spanning: single-fold-horizontal)"
    ).matches;
    if (vertical || horizontal) {
      return true;
    }
  }

  // 2. 回退到 UA + 视口尺寸检测
  const ua = (navigator.userAgent || "").toLowerCase();
  // 如果 UA 中包含 fold，则直接判为展开状态，方便本地调试
  if (ua.includes("fold")) {
    return true;
  }

  const width = Math.max(window.screen.width, window.screen.height);
  const height = Math.min(window.screen.width, window.screen.height);
  const dpr = window.devicePixelRatio || 1;
  const cssW = width / dpr;
  const cssH = height / dpr;

  // 主流折叠屏机型及其展开时的最小 CSS 视口尺寸阈值
  const foldables = [
    // Samsung Galaxy Z Fold 系列
    { key: "sm-f900", minCssW: 840, minCssH: 900 }, // Fold
    { key: "sm-f916", minCssW: 840, minCssH: 900 }, // Z Fold 2
    { key: "sm-f926", minCssW: 840, minCssH: 900 }, // Z Fold 3/4/5/6
    // Google Pixel Fold
    { key: "pixel fold", minCssW: 800, minCssH: 900 },
    // OPPO Find N 系列
    { key: "oppo find n", minCssW: 840, minCssH: 900 },
    { key: "oppo find n2", minCssW: 896, minCssH: 960 },
    { key: "oppo find n3", minCssW: 896, minCssH: 960 },
    { key: "oppo find n5", minCssW: 896, minCssH: 960 },
    // Huawei Mate X 系列
    { key: "mate x", minCssW: 840, minCssH: 900 },
    { key: "mate xs", minCssW: 840, minCssH: 900 },
    { key: "mate x2", minCssW: 840, minCssH: 900 },
    { key: "mate x3", minCssW: 840, minCssH: 900 },
    // Xiaomi MIX Fold 系列
    { key: "mix fold", minCssW: 840, minCssH: 900 },
    { key: "mix fold 2", minCssW: 840, minCssH: 900 },
    { key: "mix fold 3", minCssW: 840, minCssH: 900 },
    // OnePlus Open
    { key: "oneplus open", minCssW: 840, minCssH: 900 },
    // Honor Magic V 系列
    { key: "magic v", minCssW: 840, minCssH: 900 },
    { key: "magic v2", minCssW: 840, minCssH: 900 },
    { key: "magic v3", minCssW: 840, minCssH: 900 },
    // Vivo X Fold 系列
    { key: "x fold", minCssW: 840, minCssH: 900 },
    { key: "x fold 2", minCssW: 840, minCssH: 900 },
    // Royole FlexPai
    { key: "flexpai", minCssW: 840, minCssH: 900 },
    // Microsoft Surface Duo（双屏，非柔性屏）
    { key: "surface duo", minCssW: 720, minCssH: 900 },
  ];

  for (const dev of foldables) {
    if (ua.includes(dev.key) && cssW >= dev.minCssW && cssH >= dev.minCssH) {
      return true;
    }
  }

  return false;
}

/**
 * 判定ipad或折叠屏展开
 * @returns
 */
export const isPad = () => {
  return isTabletDevice() || isFoldableExpanded();
};

/**
 * 是否微信
 * @returns
 */
export const isWx = (mock?: boolean) =>
  mock ? true : /MicroMessenger/i.test(window.navigator.userAgent);

export function getDecimalPart(price) {
  const val = price / 100;
  const decimalStr = val.toString().split(".")[1];
  if (!decimalStr) {
    // 整数，返回 "00"
    return "00";
  } else if (decimalStr.length === 1) {
    // 只有一位小数，返回这一位加0
    return decimalStr + "0";
  } else {
    // 返回前两位小数
    return decimalStr.slice(0, 2);
  }
}